import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { numberToCurrency } from "helpers/string"
import { useSelector } from "react-redux"
import { metadataSelector } from "store/selectors"
import StatCard from "./StatCard"
import { getDateLabel } from "./utils/dateLabels"

Incomes.propTypes = {
  params: PropTypes.shape({
    overview_range: PropTypes.string.isRequired,
    date_gteq: PropTypes.string,
    date_lteq: PropTypes.string
  }).isRequired
}

export default function Incomes({ params }) {
  const { t } = useTranslation()
  const { incomes_stats } = useSelector(metadataSelector("accounting"))
  const dates = getDateLabel(params)

  return (
    <StatCard
      title={t("accounting.labels.incomes")}
      tooltip={t("accounting.labels.incomes_tooltip", { dates })}
      dates={dates}
      value={numberToCurrency(incomes_stats[params.overview_range])}
      monthlyDiff={incomes_stats.monthly_diff}
      isCurrentMonth={params.overview_range === "current_month"}
    />
  )
}
